import React from "react";
// import ReactDOM from 'react-dom/client';
import ReactDOM from "react-dom";
import Modal from "react-modal";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import App from "./app/App";

import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "./index.scss";

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <Router>
//         <App/>
//       </Router>
//     </Provider>,
//   </React.StrictMode>
// );

Modal.setAppElement("#root");

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();
serviceWorkerRegistration.register({
  onUpdate: () => {
    // window.reloadRequired is set in App.js
    // @ts-ignore
    if (window.reloadRequired) {
      // @ts-ignore
      window.reloadRequired();
    }
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
